export default __webpack_public_path__ + "static/media/gallery-image-10-full.982c8910.jpg";